import { TBootsColor } from "../../../Interfaces/Utils/Style/StyleInterfaces";

interface ISpinnerProps {
    size?: "sm" | "md" | "lg" | "xl";
    color?: TBootsColor;
}

export function Spinner(props: ISpinnerProps) {
    return (
        <div
            className={`spinner-border spinner-border${
                props.size ? `-${props.size}` : ""
            } text-${props.color}`}
            role="status"
        >
            <span className="sr-only">Carregando...</span>
        </div>
    );
}
